<template>
  <div class="main-container">
    <pageHeader createBtn :alertModal="alertModal" />

    <div class="line-loading-bar" v-if="!contentLoaded"></div>

    <section v-if="!storageIsWorking" class="bandwith-msg-cont">
      <div class="emoji">🍌</div>
      <h2>Oops!</h2>
      <div class="bandwidth title">
        Looks like we’re getting really popular and we’ve hit our daily
        bandwidth limit!
        <br /><br />
        I'm so sorry about that. Please check again in a few hours and hopefully
        the site will be back up and running.
        <br /><br />
        In the meantime you can enjoy playing a fun game that I've created at
        <a href="https://taptaptap.click">TapTapTap.click</a>
      </div>
    </section>

    <section class="cards-main-cont">
      <gifCard v-for="post in posts" :key="post.id" :postId="post.id" />
    </section>

    <button
      v-if="
        (postsCounters.totalLoaded < postsCounters.totalInDb) & contentLoaded
      "
      @click="fetchPostsFromDb"
      class="btn btn-l btn-secondary"
    >
      Load more posts
    </button>

    <section
      class="end-of-gifs"
      v-if="
        (postsCounters.totalLoaded == postsCounters.totalInDb) & contentLoaded
      "
    >
      <img src="@/assets/images/icons/24/cup.svg" alt="" />
      <h2>Whoah!</h2>
      <p>You've seen all the quizes on the website!</p>
      <hr />
      <button
        @click="scrollToTop"
        class="btn btn-l btn-secondary create-quiz-btn"
      >
        Go back to the top
      </button>
    </section>
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader";
import gifCard from "@/components/gifCard";

// Firebase
import firebase from "firebase/app";
import "firebase/database";
import "firebase/analytics";

export default {
  name: "Home",
  components: {
    pageHeader,
    gifCard,
  },
  data() {
    return {
      isPROD: process.env.NODE_ENV === "production",
      storageIsWorking: true,
      posts: [],
      creationModalShown: false,
      sideMenuShown: false,
      contentLoaded: false,
      postsCounters: {
        totalPerPage: 4,
        totalLoaded: 0,
        totalInDb: null,
      },
      alertModal: {
        shown: false,
        titleTxt: "Whoa! Easy on posting!",
        bodyTxt:
          "You’re trying to post so many quizes in a short time. Wait for a couple of minutes and try again",
        submitBtnTxt: "Got it",
        cancelBtnTxt: "Cancel",
        submitFun: function () {
          console.log("Submit button clicked");
        },
        cancelFun: function () {
          console.log("Cancel button clicked");
        },
      },
    };
  },
  methods: {
    showModal() {
      this.creationModalShown = true;
    },
    hideCreationModal() {
      this.creationModalShown = false;
    },
    fetchPostsFromDb() {
      this.contentLoaded = false;
      let database = firebase.database();

      // Get total number of posts from db
      if (!this.postsCounters.totalInDb) {
        database.ref("posts").once("value", this.gotAllData, this.errData);
      } else {
        // Fetch posts from db if it's less than total amount in db
        if (this.postsCounters.totalLoaded < this.postsCounters.totalInDb) {
          // Add another page of posts to load in next page
          this.postsCounters.totalLoaded += this.postsCounters.totalPerPage;
          database
            .ref("posts")
            .limitToLast(this.postsCounters.totalLoaded)
            .once("value", this.gotData, this.errData);
        } else {
          // Hide loading skeleton when all posts are loaded
          this.contentLoaded = true;
        }
      }
    },
    gotAllData(data) {
      this.postsCounters.totalInDb = data.numChildren();
      this.fetchPostsFromDb();
    },
    gotData(data) {
      let dataReceived = data.val();

      if (dataReceived) {
        // get cards info from db, convert JSON object to array, and add ID's
        let posts = Object.keys(dataReceived).map((key) => {
          dataReceived[key].id = key;
          return dataReceived[key];
        });

        this.postsCounters.totalLoaded = posts.length;

        // Only show public gifs (if post.public === true)
        posts = posts.filter((post) => !post.private);

        // If total number of public posts is less than what
        // 1 page can show then load more posts
        if (posts.length < this.postsCounters.totalPerPage) {
          this.fetchPostsFromDb();
        }

        // reversing array of posts to show newest on top
        this.posts = posts.reverse();

        // hide loading skeleton once content is loaded
        this.contentLoaded = true;
      }
    },
    errData(error) {
      console.error("Error while trying to get data from db", error);
    },
    infiniteScroll() {
      window.addEventListener("scroll", () => {
        let endOfPage = window.document.body.offsetHeight - window.innerHeight;

        // Load more posts when scroll is 100px before the end of the page
        if (window.scrollY > endOfPage - 100) {
          this.fetchPostsFromDb();
        }
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    checkBandwidth() {
      // —— Check if file can be downloaded.
      // Must check if app running in production or development
      // to decide which storage bucket to load the images from

      let storageFile;
      if (this.isPROD) {
        storageFile =
          "https://firebasestorage.googleapis.com/v0/b/gif-banana.appspot.com/o/posts%2F-MHweq09p8YIkCkbeOt8%2Fgifbanana.com-Mahdi-Farra-1600893182140.gif?alt=media&token=8c18c718-9399-4cc5-808c-6d8dc4452338";
      } else {
        storageFile =
          "https://firebasestorage.googleapis.com/v0/b/gifuiz.appspot.com/o/posts%2F-MJG5uBIQ3BJ7xFC70vx%2Fgifbanana.com-Anonymous-1602309825405.gif?alt=media&token=5828e201-7761-4f86-b170-a9c6aa7ff3f5";
      }

      let storage = firebase.storage();
      let httpsReference = storage.refFromURL(storageFile);
      httpsReference
        .getDownloadURL()
        .then(() => {
          this.storageIsWorking = true;
          this.fetchPostsFromDb();
          this.infiniteScroll();
        })
        .catch((error) => {
          switch (error.code) {
            case "storage/quota-exceeded":
              console.error("Yikes! ⚠️ storage bandwidth reached the limit!");
              this.storageIsWorking = false;
              break;
            case "storage/unauthorized":
              console.log("File does not exit");
              break;
          }
        });
    },
  },
  mounted() {
    // Fetch data from db and track scrolling for infinite scroll
    // this.fetchPostsFromDb();
    // this.infiniteScroll();
    this.checkBandwidth();
  },
  watch: {
    storageIsWorking: function (val) {
      // Fetch data from database only if storage is working fine.
      if (val) {
        this.fetchPostsFromDb();
        this.infiniteScroll();
      }
    },
  },
};
</script>

<style>
</style>
